import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import ChatPage from "./pages/ChatPage";
import AdminPage from "./pages/AdminPage";
import AuraMascot from "./components/AuraMascot";
import { Toaster } from "sonner";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading AfterMind…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (adminOnly && !user.admin) return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
        <Routes>
          <Route path="/" element={<><Landing /><AuraMascot /></>} />
          <Route path="/app" element={<Protected><ChatPage /></Protected>} />
          <Route path="/admin" element={<Protected adminOnly><AdminPage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
